import { useRouter } from "../../utils/routerUtils";

export default function RouteWrapper({ Component, ...rest }) {
  const router = useRouter();
  return <Component {...rest} {...router} />;
}
